<app-modal-header (closeModal)="close()"> </app-modal-header>
<app-modal-body>
  <h1 class="fs-5 text-wrap pe-2">{{ 'YOUR_MEETING_REQUEST_HAS_BEEN_REMOVED' | translate }}</h1>
  <p class="mb-0">
    {{
      'YOUR_ACCESS_TO_DISCUSS_AND_CHAT_WITH_SOMEONE_ONE_MESSAGES_FOR_THIS_MEETING_HAS_BEEN_REMOVED'
        | translate: { name }
    }}
  </p>
</app-modal-body>
<app-modal-footer classList="d-flex justify-content-center">
  <button type="button" class="btn btn-primary rounded-5 fw-medium" (click)="close()">{{ 'CLOSE' | translate }}</button>
</app-modal-footer>
